import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SnIncidentMedia } from '@lib/api/entities';

@Component({
  selector: 'sn-incident-media-list',
  templateUrl: './incident-media-list.component.html',
})
export class IncidentMediaListComponent {
  @Input()
  public media: any[];

  @Output()
  public readonly fileDeleted = new EventEmitter<SnIncidentMedia>();

  constructor() {}

  public emitItem(item: SnIncidentMedia): void {
    this.fileDeleted.emit(item);
  }
}
